// Using <NavLink> here forces to use <Router> + useLocation()

import { DocumentationNavItem, SupportNavItem } from "@digital-services/ui";

const documentationUrl = import.meta.env.VITE_APP_DOCUMENTATION_URL as string;

export const FooterNavigationItems = () => {
  return (
    <>
      <SupportNavItem href="https://e-mobility.abb.com/en/contact-us" />
      <DocumentationNavItem href={documentationUrl} />
    </>
  );
};
